module.exports = __webpack_public_path__ + "images/professionals-mobile.png";